window.testimonialCardsFunc = function testimonialCardsFunc() {
  const testimonialCardsArr = document.querySelectorAll('.testimonial-card');

  let testimonialContainersArr = [];

  testimonialCardsArr.forEach((testimonialCard) => {
    if (!testimonialCard.classList.contains('is-init-testimonial-card')) {
      testimonialCard.classList.add('is-init-testimonial-card');

      const testimonialContainerEl = testimonialCard.querySelector(
        '.testimonial-card__container'
      );
      const testimonialCardTextEl = testimonialCard.querySelector(
        '.testimonial-card__text'
      );

      if (testimonialCardTextEl) {
        testimonialCardTextEl.querySelectorAll('p').forEach((p) => {
          if (!p.textContent.trim()) {
            p.remove();
          }
        });
      }

      if (testimonialContainerEl) {
        testimonialContainersArr.push(testimonialContainerEl);
      }
    }
  });

  function containersHeightFunc(containersArr) {
    let maxHeight = 0;

    containersArr.forEach((container) => {
      const height = container.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    containersArr.forEach((container) => {
      container.style.minHeight = maxHeight + 'px';
    });
  }

  if (window.innerWidth > 640) {
    containersHeightFunc(testimonialContainersArr);
  }
};

testimonialCardsFunc();

gsap.registerPlugin(ScrollTrigger);

const testimonialsGrid = document.querySelector(
  '.our-testimonials-sec__container'
);
const title = document.querySelector(
  '.testimonials-first-sec .first-sec__title'
);

if (testimonialsGrid && title) {
  const isTablet = window.matchMedia('(max-width: 1024px)').matches;
  testimonialsGrid.classList.add('animated');

  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  if (!isTablet) {
    const moveY = 150;
    const columns = testimonialsGrid.querySelectorAll('[data-speed]');

    let maxShift = 0;
    columns.forEach((col) => {
      const speed = parseFloat(col.dataset.speed);
      const maxScroll = testimonialsGrid.scrollHeight - window.innerHeight;
      const shift = Math.abs(maxScroll * (speed - 1) * 0.45);
      if (shift > maxShift) maxShift = shift;
    });

    if (window.innerWidth > 551) {
      testimonialsGrid.style.maxHeight = `${
        testimonialsGrid.scrollHeight - +maxShift.toFixed(2) / 0.75
      }px`;
    }

    gsap.to(testimonialsGrid, {
      y: -moveY,
      ease: 'none',
      scrollTrigger: {
        trigger: title,
        start: 'top 20%',
        end: () => '+=' + (title.offsetHeight + 200),
        scrub: true,
        // markers: true,
      },
    });

    columns.forEach((column) => {
      const speed = parseFloat(column.dataset.speed);
      const maxScroll = testimonialsGrid.scrollHeight - window.innerHeight;

      gsap.to(column, {
        y: () => -maxScroll * (speed - 1) * 0.8,
        ease: 'none',
        scrollTrigger: {
          trigger: testimonialsGrid,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          // markers: true,
        },
      });
    });
  }
}
